module.exports = __webpack_public_path__ + "img/QN800B.805b1499.png";